require('slick-carousel');

let rtl = false;
if ($('body').hasClass('ar')) {
	rtl = true
}

var numSliderSlick = 0;
$('.slider').each(function () {

	let fade = false;
	let autoplay = false;
	if ($(this).hasClass('wFade')) {
		fade = true;
	}
	if ($(this).hasClass('wautoplay')) {
		autoplay = true;
	}
	numSliderSlick++;
	let slider=$(this).addClass('slider-' + numSliderSlick).slick({
		autoplay: false,

		fade: fade,

		autoplaySpeed:4000,

		speed: 600,
		cssEase: 'linear',
		pauseOnHover: true,
		autoplay: autoplay,
		rtl: rtl,



		lazyLoad: 'progressive',
		// arrows: true,
		dots: true,
		arrows: false,
		// prevArrow: '<div class="slick-nav prev-arrow"><i></i><svg><use xlink:href="#circle"></svg></div>',
		// nextArrow: '<div class="slick-nav next-arrow"><i></i><svg><use xlink:href="#circle"></svg></div>',
		responsive: [{

			breakpoint: 992,
			settings: {
				arrows: false,
			}

		}],
	}).slickAnimation();



	if ($(this).parent('.banner__slider').hasClass('dayNight')) {


		

		$(".toggle-control .input").on("change", function () {
			colorModePreview(this);
			slider.slick('slickPause');
			setTimeout(function() { 
				slider.slick('slickPlay');

			}, 400);
			
		})

		function colorModePreview(ele) {
			if ($(ele).prop("checked") == true) {
				$('body').addClass('dark-preview').removeClass('white-preview');


				$('.dayNight').addClass('night').removeClass('day');
				$('.dayNight img.day').removeClass('active')
				$('.dayNight img.night').addClass('active')
			} else if ($(ele).prop("checked") == false) {

				$('body').addClass('white-preview').removeClass('dark-preview');


				$('.dayNight').addClass('day').removeClass('night');

				$('.dayNight img.night').removeClass('active')
				$('.dayNight img.day').addClass('active')





			}
		}


	}
});


//





$('.items').slick({
	// slidesToShow:5,
	// slidesToScroll:1,
	// variableWidth: true,


	infinite: false,
	slidesToShow: 5,
	// slidesToScroll:1,
	centerMode: false,
	rtl: rtl,


	// infinite: false,
	prevArrow: $('.arrows #prev'),
	nextArrow: $('.arrows #next'),
	responsive: [{
			breakpoint: 1400,
			settings: {
				slidesToShow: 4,
			}
		},
		{
			breakpoint: 991,
			settings: {
				slidesToShow: 3,
			}
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 520,
			settings: {
				slidesToShow: 1,
			}
		}
	]
});















//menu items
$('.car .dropdown-menu').on({
	"click": function (e) {
		e.stopPropagation();
	}
});
// $('.menuSlider').slick({
//   autoplay: false,
//   speed: 800,
//   infinite:false,
//   // fade:true,
//   lazyLoad: 'progressive',
//   // arrows: true,
//   dots: false,
//   arrows:true,
//     // prevArrow: '<div class="slick-nav prev-arrow"><i></i><svg><use xlink:href="#circle"></svg></div>',
//     // nextArrow: '<div class="slick-nav next-arrow"><i></i><svg><use xlink:href="#circle"></svg></div>',
//     responsive: [{

//       breakpoint: 992,
//       settings: {
//           // arrows: false,
//           // dots: true,
//       }

//     }],
// }).slickAnimation();
// //end menu items
